import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PipelineTile } from './PipelineTile';
import { PILOT_WORKFLOW_PIPELINES } from '../config/pipelines';

const PIPELINE_THEME = {
  encapsulation: 'lapisGradient',
  stability: 'lapisUpperRight',
  size: 'orangeGradient',
  pressure: 'orangeUpperRight',
  mapping: 'greenGradient',
  'ribo-green': 'greenUpperRight',
};

const PIPELINES_WITH_BATCH_FLOWS = new Set(['encapsulation', 'size']);

export function PipelineTiles({ onRunPipeline, onOpenBatchEntry }) {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
      {PILOT_WORKFLOW_PIPELINES.map(({ id, title, description, icon, action }) => {
        const variant = PIPELINE_THEME[id] || 'lapisGradient';
        const isBatchCentric = PIPELINES_WITH_BATCH_FLOWS.has(id);

        const handleSelect =
          action.type === 'modal'
            ? () =>
                isBatchCentric && onOpenBatchEntry
                  ? onOpenBatchEntry(id)
                  : onRunPipeline(action.pipeline)
            : () => navigate(action.to);

        const primaryAction =
          isBatchCentric && onOpenBatchEntry
            ? () => onOpenBatchEntry(id)
            : handleSelect;
        const primaryLabel =
          isBatchCentric && action.type === 'modal'
            ? 'Start'
            : action.type === 'modal'
            ? 'Run'
            : 'Open';

        const secondaryAction = null;

        return (
          <PipelineTile
            key={id}
            title={title}
            description={description}
            icon={icon}
            variant={variant}
            onSelect={primaryAction}
            ctaLabel={primaryLabel}
            secondaryCtaLabel={secondaryAction ? 'Open batch workspace' : undefined}
            onSecondaryAction={secondaryAction}
            onQuickRun={
              isBatchCentric
                ? undefined
                : action.type === 'modal'
                ? () => onRunPipeline(id)
                : undefined
            }
          />
        );
      })}
    </div>
  );
}
